import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #ffffff;
    color: #1a1a1a;
    line-height: 1.6;
    overflow-x: hidden;
    min-width: 320px;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    line-height: 1.2;
    word-wrap: break-word;
  }

  a {
    text-decoration: none;
    color: inherit;
    -webkit-tap-highlight-color: transparent;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ::selection {
    background: #0891b2;
    color: white;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background: #0891b2;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #0e7490;
  }

  /* Mobile-specific styles */
  @media (max-width: 768px) {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
  }

  /* Prevent horizontal scroll on mobile */
  @media (max-width: 768px) {
    html, body {
      overflow-x: hidden;
      position: relative;
    }
  }
`;

export default GlobalStyles; 